import type { HeaderMatcher } from './SelectorUtil.js'
import { defaultMatchers } from './MatcherImpl.js'

export type CSVFieldType =
  | 'forwardPrimer'
  | 'reversePrimer'
  | 'sequenceId'
  | 'customerSample'
  | 'coordinatesMerged'
  | 'coordinatesLat'
  | 'coordinatesLon'
  | 'samplingDate'
  | 'samplingStart'
  | 'samplingEnd'
  | 'matrixType'
  | 'extractionKit'
  | 'trapType'
  | 'collectionType'
  | 'sequencer'
  | 'sequencingChemistry'
  | 'sequencingDepth'
  | 'localityType'
  | 'habitatType'

export function identifyCSVSuggestion(
  targetType: CSVFieldType,
  csvHeaders: string[],
  data: Record<string, string>[],
  matchers: Record<CSVFieldType, HeaderMatcher[]> = defaultMatchers
): [string, number] | undefined {
  for (const entry of csvHeaders.map((value, index): [string, number] => [value, index])) {
    const matcher = (matchers[targetType] ?? []).find((m) => m.matcher(entry[0], csvHeaders, data))
    if (matcher) {
      console.info(`Using column with header ${entry[0]} as key for type ${targetType} 
            due to matcher ${matcher.label}`)
      return entry
    }
  }
  return undefined
}
